import { SVGProps, memo } from 'react';
const CommentIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={props.width || "25"} height={props.height || "25"} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="comment">
      <path id="Union" d="M12.849 16.8018L12.7094 16.6841H12.5268H10.881C7.63219 16.6841 4.98096 13.9924 4.98096 10.6502C4.98096 7.30789 7.63219 4.61621 10.881 4.61621H14.081C17.3297 4.61621 19.981 7.30789 19.981 10.6502C19.981 12.9297 18.7458 14.9103 16.9275 15.9368L16.583 16.1312L16.693 16.5112L17.7618 20.2032C17.8074 20.3607 17.7456 20.4888 17.6363 20.5626C17.5285 20.6353 17.4017 20.6392 17.2878 20.5432L12.849 16.8018Z" stroke={props.stroke || "#424242"} strokeOpacity={props.strokeOpacity || "0.5"}/>
    </g>
  </svg>
);

export default memo(CommentIcon);
